module.exports = __webpack_public_path__ + "./images/pick-location.f08088.jpg";